// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { NotificationType } from "./notification-type";
import { RecipientKind } from "./recipient-kind";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * A single destination owned directly by a notification.
 *
 * A recipient is one of three kinds (see `kind`): a literal ADDRESS, a named
 * USER, or a ROLE standing for every user holding it. Literal addresses carry
 * their destination in `value`; USER and ROLE rows resolve theirs at delivery
 * time and write `value` as the empty string, since a `(required)` field
 * cannot be omitted without breaking readers that predate `kind`.
 *
 * Channels come from the `channels` bit mask, falling back to the single
 * `type` for rows written before the mask existed. These destinations are
 * notified in addition to any users assigned via NotificationUser.
 */
export class NotificationRecipient implements flatbuffers.IUnpackableObject<NotificationRecipientT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NotificationRecipient {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNotificationRecipient(
    bb: flatbuffers.ByteBuffer,
    obj?: NotificationRecipient,
  ): NotificationRecipient {
    return (obj || new NotificationRecipient()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsNotificationRecipient(
    bb: flatbuffers.ByteBuffer,
    obj?: NotificationRecipient,
  ): NotificationRecipient {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NotificationRecipient()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  notificationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  type(): NotificationType {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : NotificationType.EMAIL;
  }

  value(): string;
  value(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  value(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * What this row points at. ADDRESS (the zero value) keeps every recipient
   * written before this field existed reading as a literal destination.
   * Appended last to preserve `FlatBuffer` backward compatibility.
   */
  kind(): RecipientKind {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : RecipientKind.ADDRESS;
  }

  /**
   * Set when `kind` is USER. The destination is resolved from the user's
   * email and address book at delivery time, not copied here.
   */
  userId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Set when `kind` is ROLE. The destinations are every user holding this
   * role, resolved at delivery time so the group stays LIVE — a member who
   * joins the role tomorrow is notified without the rule being edited.
   */
  roleId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Delivery channels for this recipient as a bit mask of
   * `NotificationChannel` (EMAIL 1 | SMS 2 | WHATSAPP 4), so one recipient
   * can be reached on several at once. 0 means "not set — use the
   * notification's `channels`, and failing that the legacy `type`".
   */
  channels(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  static startNotificationRecipient(builder: flatbuffers.Builder) {
    builder.startObject(12);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addNotificationId(builder: flatbuffers.Builder, notificationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, notificationIdOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, organizationIdOffset, 0);
  }

  static addType(builder: flatbuffers.Builder, type: NotificationType) {
    builder.addFieldInt8(3, type, NotificationType.EMAIL);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, valueOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, deletedAtOffset, 0);
  }

  static addKind(builder: flatbuffers.Builder, kind: RecipientKind) {
    builder.addFieldInt8(8, kind, RecipientKind.ADDRESS);
  }

  static addUserId(builder: flatbuffers.Builder, userIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, userIdOffset, 0);
  }

  static addRoleId(builder: flatbuffers.Builder, roleIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, roleIdOffset, 0);
  }

  static addChannels(builder: flatbuffers.Builder, channels: number) {
    builder.addFieldInt8(11, channels, 0);
  }

  static endNotificationRecipient(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // notification_id
    builder.requiredField(offset, 8); // organization_id
    builder.requiredField(offset, 12); // value
    return offset;
  }

  unpack(): NotificationRecipientT {
    return new NotificationRecipientT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.notificationId() !== null ? this.notificationId()!.unpack() : null,
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.type(),
      this.value(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.kind(),
      this.userId() !== null ? this.userId()!.unpack() : null,
      this.roleId() !== null ? this.roleId()!.unpack() : null,
      this.channels(),
    );
  }

  unpackTo(_o: NotificationRecipientT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.notificationId = this.notificationId() !== null ? this.notificationId()!.unpack() : null;
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.type = this.type();
    _o.value = this.value();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.kind = this.kind();
    _o.userId = this.userId() !== null ? this.userId()!.unpack() : null;
    _o.roleId = this.roleId() !== null ? this.roleId()!.unpack() : null;
    _o.channels = this.channels();
  }

  unpackFields(...fields: string[]): NotificationRecipientT {
    const t = new NotificationRecipientT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("notification_id")) {
      t.notificationId = this.notificationId() !== null ? this.notificationId()!.unpack() : null;
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("type")) {
      t.type = this.type();
    }
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("kind")) {
      t.kind = this.kind();
    }
    if (fieldSet.has("user_id")) {
      t.userId = this.userId() !== null ? this.userId()!.unpack() : null;
    }
    if (fieldSet.has("role_id")) {
      t.roleId = this.roleId() !== null ? this.roleId()!.unpack() : null;
    }
    if (fieldSet.has("channels")) {
      t.channels = this.channels();
    }
    return t;
  }
}

export class NotificationRecipientT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public notificationId: UuidT | null = null,
    public organizationId: UuidT | null = null,
    public type: NotificationType = NotificationType.EMAIL,
    public value: string | Uint8Array | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public kind: RecipientKind = RecipientKind.ADDRESS,
    public userId: UuidT | null = null,
    public roleId: UuidT | null = null,
    public channels: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.notificationId === null || this.notificationId === undefined) {
      throw new Error('Required field "notification_id" is not set');
    }
    if (this.organizationId === null || this.organizationId === undefined) {
      throw new Error('Required field "organization_id" is not set');
    }
    if (this.value === null || this.value === undefined) {
      throw new Error('Required field "value" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const notificationId = this.notificationId !== null ? this.notificationId!.pack(builder) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const value = this.value !== null ? builder.createString(this.value!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const userId = this.userId !== null ? this.userId!.pack(builder) : 0;
    const roleId = this.roleId !== null ? this.roleId!.pack(builder) : 0;

    NotificationRecipient.startNotificationRecipient(builder);
    NotificationRecipient.addId(builder, id);
    NotificationRecipient.addNotificationId(builder, notificationId);
    NotificationRecipient.addOrganizationId(builder, organizationId);
    NotificationRecipient.addType(builder, this.type);
    NotificationRecipient.addValue(builder, value);
    NotificationRecipient.addCreatedAt(builder, createdAt);
    NotificationRecipient.addUpdatedAt(builder, updatedAt);
    NotificationRecipient.addDeletedAt(builder, deletedAt);
    NotificationRecipient.addKind(builder, this.kind);
    NotificationRecipient.addUserId(builder, userId);
    NotificationRecipient.addRoleId(builder, roleId);
    NotificationRecipient.addChannels(builder, this.channels);

    return NotificationRecipient.endNotificationRecipient(builder);
  }

  clone(): NotificationRecipientT {
    const obj = new NotificationRecipientT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.notificationId = this.notificationId !== null ? this.notificationId!.clone() : null;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.type = this.type;
    obj.value = this.value;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.kind = this.kind;
    obj.userId = this.userId !== null ? this.userId!.clone() : null;
    obj.roleId = this.roleId !== null ? this.roleId!.clone() : null;
    obj.channels = this.channels;
    return obj;
  }

  equals(other: NotificationRecipientT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.notificationId !== null && other.notificationId !== null) {
      if (!this.notificationId!.equals(other.notificationId!)) return false;
    } else if (this.notificationId !== other.notificationId) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.type !== other.type) return false;
    if (this.value !== other.value) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.kind !== other.kind) return false;
    if (this.userId !== null && other.userId !== null) {
      if (!this.userId!.equals(other.userId!)) return false;
    } else if (this.userId !== other.userId) return false;
    if (this.roleId !== null && other.roleId !== null) {
      if (!this.roleId!.equals(other.roleId!)) return false;
    } else if (this.roleId !== other.roleId) return false;
    if (this.channels !== other.channels) return false;
    return true;
  }
}

export function verifyNotificationRecipient(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "notification_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "organization_id");
    verifier.checkScalarField(tablePos, 10, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "value");
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 20, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 22);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 24);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 26, 1);
  } finally {
    verifier.popDepth();
  }
}
